import React, { Component, PropTypes } from 'react';

import Tag from 'components/Tag/Tag';
import Autocomplete from 'components/Autocomplete/Autocomplete';
import CheckboxOption from 'components/Autocomplete/AutocompleteCheckboxOption';
import QueryTextHighlightOption from 'components/Autocomplete/AutocompleteQueryTextHighlightOption';

import './SearchUnitDepartureAirport.scss';

export default class SearchUnitDepartureAirport extends Component {
  static propTypes = {
    options: PropTypes.arrayOf(PropTypes.object),
    addDepartureAirport: PropTypes.func.isRequired,
    removeDepartureAirport: PropTypes.func.isRequired,
  };

  renderOption(option, isFocused, query) {
    return (
      <CheckboxOption checked={option.checked} unavailable={option.unavailable} focused={isFocused} >
        <QueryTextHighlightOption label={option.label} query={query} />
      </CheckboxOption>
    );
  }

  renderTag(option, deselect) {
    return <Tag isFullWidth onTagClick={deselect}>{option.label}</Tag>;
  }

  render() {
    const {
      options,
      addDepartureAirport,
      removeDepartureAirport,
    } = this.props;

    const hasSelectedAirports = !!options.find(option => option.checked);

    return (
      <div className="search-unit-departure">
        <label className="search-unit-departure__label">Departure Airport:</label>
        <div className="search-unit-departure__field">
          <div className="search-unit-departure__input__wrapper">
            <Autocomplete
              options={options}
              onOptionSelect={addDepartureAirport}
              onOptionDeselect={removeDepartureAirport}
              optionRenderer={this.renderOption}
              tagRenderer={this.renderTag}
              placeholder={hasSelectedAirports ? '+ Add another' : 'Any'}
            />
          </div>
        </div>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/SearchUnitDepartureAirport/SearchUnitDepartureAirport.jsx
 **/